import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugCitalopram} from "./TextDrugCitalopram"


export default function Citalopram() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Citalopram' size='large' color='common.white' />

    <CustomDialog open={open} onClose={handleClose}

        title="Citalopram - PGx Recommendation"
        content={ <TextDrugCitalopram />}

        />

</>
)}